import type * as api from "../api/client";

/** Reconstruct the page-primary speaker from an NPC payload. The
 *  server emits it as `npc.speakers[npc.id]`, but a couple of
 *  callsites need a safe fallback (e.g. ChallengeFightModal when an
 *  entry doesn't declare its own speaker, or NpcView when an authored
 *  node references a missing speaker id). Synthesizing from the
 *  page-level NPC fields matches what the server does internally so
 *  both surfaces show the same identity. */
export function primarySpeaker(npc: api.NpcPayload): api.NpcSpeaker {
  return (
    npc.speakers?.[npc.id] ?? {
      id: npc.id,
      name: npc.name,
      faction: npc.faction,
      role: npc.role,
      portrait_id: npc.default_image ?? npc.id,
      default_mood: npc.default_mood,
      is_primary: true,
    }
  );
}
